// removed by extract-text-webpack-plugin
module.exports = {"emailDefault":"jPrqCn369RN_APfAThgrp","dataElement":"_2iiXQJzm8WkV4AqOEYY8n","dataLabel":"pg2iU5h0Y3pzclLPKCBl6","dataValue":"_1PjC1cqbdeg2U0FdyDYoKR"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/client-profile/ClientProfileData.scss
// module id = 1160
// module chunks = 0